import {FC} from 'react'
import {InputConfirmation, UploadStep} from '..'
import UploadContactFooter from '../Element/UploadContactFooter'
import {Alert} from 'react-bootstrap'
import moment from 'moment-timezone'

export type ConfirmationProps = {
  confirmationCheck: InputConfirmation
  error: string
  isLoading: boolean
  csvLength: number
  handleClose: () => void
  setActiveState: (state: UploadStep) => void
  handleNext: () => void
  setConfirmationCheck: (check: InputConfirmation) => void
}

const Confirmation: FC<ConfirmationProps> = (props) => {
  const {
    isLoading,
    confirmationCheck,
    error,
    csvLength,
    setActiveState,
    setConfirmationCheck,
    handleNext,
    handleClose,
  } = props

  const batchSize = 50000
  const timePerBatchMinutes = 3.5

  // Calculate number of batches
  const numBatches = csvLength / batchSize

  // Calculate total time in minutes
  const totalTimeMinutes = numBatches * timePerBatchMinutes

  // Get the current date and time
  const currentTime = new Date()

  // Calculate the estimated completion time
  const endDate = moment(new Date(currentTime.getTime() + totalTimeMinutes * 60 * 1000));

  // Separate date and time
  const dateOnly = endDate.format('DD/MM/YYYY');
  const timeOnly = endDate.format('LT');

  return (
    <div className='modal-body mb-10 ms-10'>
      {error.length > 0 && (
        <Alert variant='danger'>
          <Alert.Heading>Error</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}
      <div className='form-check form-check-sm form-check-custom form-check-solid'>
        <input
          onChange={(e) =>
            setConfirmationCheck({
              ...confirmationCheck,
              allowPermission: e.target.value === 'on',
            })
          }
          value={confirmationCheck.allowPermission ? 'off' : 'on'}
          checked={confirmationCheck.allowPermission}
          className='form-check-input me-3'
          id='first'
          type='checkbox'
          data-kt-check='true'
        />
        <div>
          <label htmlFor='first' style={{lineHeight: '1.65'}}>
            This persons have given me permission to message them.
          </label>
        </div>
      </div>
      <div className='form-check form-check-sm form-check-custom form-check-solid mt-4 mb-10'>
        <input
          onChange={(e: any) =>
            setConfirmationCheck({
              ...confirmationCheck,
              allowUpdateProfile: e.target.value === 'on',
            })
          }
          value={confirmationCheck.allowUpdateProfile ? 'off' : 'on'}
          checked={confirmationCheck.allowUpdateProfile}
          className='form-check-input me-3'
          id='second'
          type='checkbox'
          data-kt-check='true'
        />
        <div>
          <label htmlFor='second' style={{lineHeight: '1.65'}}>
            If this person is already in my audience, update their profile
          </label>
        </div>
      </div>

      {csvLength > batchSize && (
        <p className='text-bolder text-danger' style={{lineHeight: '1.65'}}>
          *It appears you have uploaded a larger number of contacts. The system will automatically split the file, and you can track the progress in the Contacts Upload History menu. The upload is expected to be completed by approximately{' '}
          {dateOnly} on {timeOnly}
        </p>
      )}

      <UploadContactFooter
        isLoading={isLoading}
        allowedNext={
          !isLoading && confirmationCheck.allowPermission && confirmationCheck.allowUpdateProfile
        }
        handleClose={handleClose}
        handleBack={() => setActiveState(UploadStep.SetOptions)}
        handleNext={handleNext}
      />
    </div>
  )
}

export default Confirmation
